import { errorHandler } from '../../../util/error.service'
import * as routes from '../../routes/registration.routes'
import { authHttp } from '../http'

export async function saveTransportadora(transportadora, tp_id) {
  try {
    const response = await authHttp().post(routes.urlSaveTransportadora(tp_id), transportadora)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateTransportadora(transportadora) {
  try {
    const response = await authHttp().put(routes.urlUpdateTransportadora(), transportadora)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTransportadoras(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetTransportadoras(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteTransportadora(tpId, transportadoraId) {
  try {
    const response = await authHttp().delete(routes.urlDeleteTransportadora(tpId, transportadoraId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
